import React, { useCallback, useEffect, useState } from 'react'
import { Button, Grid } from '@mui/material'

import PageUrls from '../../../../../../constants/page-urls'
import { ContentWrapper } from '../../../../../../components/ContentWrapper'
import Helmet from '../../../../../../components/Helmet'
import HeaderContent from '../../../../../../components/Layouts/HeaderContent'
import MerchantDetailCard from '../../components/MerchantDetailCard'
import MerchantPermissionCard from '../../components/MerchantPermissionCard'
import MerchantSetUpProductsAndOrdersCard from '../../components/MerchantSetUpProductsAndOrdersCard'
import MerchantOrderDisplayCard from '../../components/MerchantOrderDisplayCard'
import MerchantSetUpBankAccountCard from '../../components/MerchantSetUpBankAccountCard'
import AddIcon from '@mui/icons-material/Add'
import { axiosInstance } from '../../../../../../hooks/useAxios'
import { message } from 'antd'
import { IMerchant, IMerchantConfig } from '../../../../../../types/merchant'
import CircularLoading from '../../../../../../components/CircularProgress'
import { ERRORS_MESSAGE_MAPPER } from '../../../../../../constants/errors'
import { clearMerchantCache } from '../../../../../../utils/cache'
import { add } from 'lodash'
import { config } from 'process'
import { Commission } from '../../../../../../resources/report'
import { display } from 'styled-system'

const Menus: any[] = []

const GeneralListPage = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [merchant, setMerchant] = useState<IMerchant>()

  useEffect(() => {
    const fetchMerchant = async () => {
      setIsLoading(true)
      try {
        const response = await axiosInstance.get<IMerchant>('/merchant/me')
        const { data } = response
        setMerchant(data)
      } catch (e: any) {
        const messageError =
          ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
          'บันทึกข้อมูลไม่สำเร็จ'
        message.error(messageError)
      }
      setIsLoading(false)
    }
    fetchMerchant()
  }, [])

  const handleUpdateMerchant = async () => {
    const { name, address, phoneNumber, taxIdentificationNumber } =
      merchant || {}
    if (!name || !address || !phoneNumber || !taxIdentificationNumber) {
      message.error(
        'กรุณากรอก ชื่อบริษัท, ที่อยู่บริษัท, เบอร์โทรศัพท์ และเลขประจำตัวผู้เสียภาษี',
      )
      return
    }
    setIsLoading(true)
    try {
      // const deletetesKeys = ['id', 'config', 'expiresDate', 'prefix', 'updatedAt', 'createdAt', 'facebookAccessToken']

      const data = {
        address: merchant?.address,
        config: {
          bank: merchant?.config?.bank,
          comission: merchant?.config?.comission || 0,
          commissionOrder: merchant?.config?.commissionOrder || 0,
          commissionPercent: merchant?.config?.commissionPercent || 0,
          codPercent: merchant?.config?.codPercent || 0,
          display: merchant?.config?.display,
          returnPercent: merchant?.config?.returnPercent || 0,
          shippingCostFix: merchant?.config?.shippingCostFix || 0,
          taxPercent: merchant?.config?.taxPercent || 0,
          dulplicateOrderDate: merchant?.config?.dulplicateOrderDate || 1,
        },
        district: merchant?.district,
        name: merchant?.name,
        phoneNumber: merchant?.phoneNumber,
        province: merchant?.province,
        subdistrict: merchant?.subdistrict,
        taxIdentificationNumber: merchant?.taxIdentificationNumber,
        zipcode: merchant?.zipcode,
      }

      await axiosInstance.put('/merchant/update/settings', data)
      // the cached merchant lives 12h, so display toggles would not take effect until then
      clearMerchantCache()
      message.success('บันทึกข้อมูลร้านค้าสำเร็จ')
    } catch (e: any) {
      const messageError =
        ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
        'บันทึกข้อมูลไม่สำเร็จ'
      message.error(messageError)
    }
    setIsLoading(false)
  }

  const updateMerchant = useCallback(
    (data: Partial<IMerchant>) => {
      setMerchant(
        (prevMerchant: IMerchant | undefined) =>
          prevMerchant && {
            ...prevMerchant,
            ...data,
          },
      )
    },
    [merchant, setMerchant],
  )

  return (
    <ContentWrapper>
      <Helmet title="ตั้งค่าร้าน" />
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title="ตั้งค่าร้าน"
            routes={Menus}
            descriptions="ตั้งค่าร้าน"
          />
        </Grid>
        <Grid item mb={2}>
          <Button
            variant="contained"
            size="large"
            startIcon={<AddIcon />}
            onClick={handleUpdateMerchant}
          >
            บันทึกข้อมูล
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        {isLoading ? (
          <CircularLoading isLoading={isLoading} />
        ) : (
          <>
            <Grid item xs={12} lg={4}>
              <MerchantDetailCard
                isLoading={isLoading}
                merchant={merchant}
                updateMerchant={updateMerchant}
              />
            </Grid>
            <Grid item xs={12} lg={4}>
              <MerchantSetUpProductsAndOrdersCard
                isLoading={isLoading}
                merchant={merchant}
                updateMerchant={updateMerchant}
              />
            </Grid>
            <Grid item xs={12} lg={4} />
            <Grid item xs={12} lg={4}>
              <MerchantPermissionCard
                isLoading={isLoading}
                merchant={merchant}
                updateMerchant={updateMerchant}
              />
            </Grid>
            <Grid item xs={12} lg={4}>
              <MerchantOrderDisplayCard
                isLoading={isLoading}
                merchant={merchant}
                updateMerchant={updateMerchant}
              />
            </Grid>
            <Grid item xs={12} lg={4} />
            <Grid item xs={12} lg={4}>
              <MerchantSetUpBankAccountCard
                isLoading={isLoading}
                merchant={merchant}
                updateMerchant={updateMerchant}
              />
            </Grid>
          </>
        )}
      </Grid>
    </ContentWrapper>
  )
}

export default GeneralListPage
